import { useEffect } from 'react'
import { usePageTitle } from '@/contexts/PageTitleContext'
import CourtesyCarPlanningPanel from '@/components/CourtesyCarPlanningPanel'

export default function CourtesyCarPlanningPage() {
  const { setTitle } = usePageTitle()
  useEffect(() => { setTitle('Pianificazione Auto di Cortesia') }, [setTitle])
  return <CourtesyCarPlanningPanel />
}
